import React, { useState, useEffect, useMemo } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { addNewNormative, updateNormative } from '../../../../slices/normative/thunk';
import { setRequireCloseModal } from '../../../../slices/normative/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { getNormativeCategoryList, getNormativeEntityList, getNormativeStatusList } from '../../../../helpers/normative/backend_helper';
import OSelect from '../../../../Components/OElements/OSelect';
import ObligationForm from './ArticleForm';
import { getYearsItemsSelect } from '../../../../helpers/utils/functions';

const NormativeForm = ({
	dataNormative,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();
	const itemsSelectYear = getYearsItemsSelect(1950, new Date().getFullYear() + 1);

	const [selectedNormativeEntity, setSelectedNormativeEntity] = useState(null);
	const handleNormativeEntitySelected = (optionSelected) => {
		setSelectedNormativeEntity(optionSelected);
	};

	const [selectedNormativeCategory, setSelectedNormativeCategory] = useState(null);
	const handleNormativeCategorySelected = (optionSelected) => {
		setSelectedNormativeCategory(optionSelected);
	};

	const [selectedNormativeStatus, setSelectedNormativeStatus] = useState(null);
	const handleNormativeStatusSelected = (optionSelected) => {
		setSelectedNormativeStatus(optionSelected);
	};

	const [selectedYear, setSelectedYear] = useState(null);
	const handleYearSelected = (optionSelected) => {
		setSelectedYear(optionSelected);
	};



	const [nationalCheck, setNationalCheck] = useState(dataNormative.national || false);
	const [internalCheck, setInternalCheck] = useState(dataNormative.internal || false);

	const handleNationalCheckboxChange = () => {
		setNationalCheck(!nationalCheck);
	};
	const handleInternalCheckboxChange = () => {
		setInternalCheck(!internalCheck);
	};


	const selectorNormative = createSelector(
		state => state.Normatives,
		normative => ({
			isAdding: normative.isAdding,
			isAdded: normative.isAdded,
			isUpdating: normative.isUpdating,
			isUpdated: normative.isUpdated,
			isLoadingList: normative.isLoadingList,
			requireCloseModal: normative.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorNormative);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			name: (dataNormative && dataNormative.name) || '',
			number: (dataNormative && dataNormative.number) || '',
			year: '',
			link: (dataNormative && dataNormative.link) || '',
			bcn_code: (dataNormative && dataNormative.bcn_code) || '',
			normative_entity_ids: [],
			normative_status_id: '',
			normative_category_id: '',
			normative_status_id: '',
			national: dataNormative.national,
			internal: dataNormative.internal,
			disabled: dataNormative.disabled,
			header: (dataNormative && dataNormative.header) || '',
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Campo requerido'),
			number: Yup.string().required('Campo requerido'),
			year: Yup.string().required('Campo requerido'),
			link: Yup.string().url(' El enlace no es válido').required('Campo requerido'),
			normative_entity_ids: Yup.array().of(Yup.string()),
			normative_status_id: Yup.string().required('Campo requerido'),
			normative_category_id: Yup.string().required('Campo requerido'),
			normative_status_id: Yup.string().required('Campo requerido'),
			bcn_code: Yup.string().required('Campo requerido'),
			header: Yup.string().required('Campo requerido'),
		}),
		onSubmit: values => {
			const normative = {
				name: values.name,
				number: values.number,
				year: values.year,
				link: values.link,
				national: nationalCheck,
				internal: internalCheck,
				normative_entity_ids: values.normative_entity_ids,
				normative_category_id: values.normative_category_id,
				normative_status_id: values.normative_status_id,
				bcn_code: values.bcn_code,
				header: values.header,
			};

			if (isEdit) {
				normative._id = dataNormative._id;
				dispatch(updateNormative(normative));
			} else {
				dispatch(addNewNormative(normative));
			}
		}

	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody>
				{/* <TabContent activeTab={activeTab}>
					<TabPane tabId='1'> */}
				<Row className='g-3'>
					<Col lg={8}>
						<Label for='name' className='form-label'>
							Nombre
						</Label>
						<Input
							name='name'
							id='name'
							className='form-control'
							placeholder='Ingrese un nombre'
							type='text'
							validate={{ required: { value: true } }}
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.name || ''}
							invalid={
								validation.touched.name &&
									validation.errors.name
									? true
									: false
							}
						/>
						{
							validation.touched.name &&
								validation.errors.name ? (
								<FormFeedback type='invalid'>
									{validation.errors.name}
								</FormFeedback>
							) : null
						}
					</Col>
					<Col lg={2}>
						<Label for='number' className='form-label'>
							Número
						</Label>
						<Input
							name='number'
							id='number'
							className='form-control'
							placeholder='Ingrese un nro'
							type='text'
							validate={{ required: { value: true } }}
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.number || ''}
							invalid={
								validation.touched.number &&
									validation.errors.number
									? true
									: false
							}
						/>
						{validation.touched.number && validation.errors.number ? (
							<FormFeedback type='invalid'>
								{validation.errors.email}
							</FormFeedback>
						) : null}
					</Col>
					<Col lg={2}>
						<OSelect
							key='year'
							label='Año'
							id='year'
							name='year'
							value={dataNormative?.year || ''}
							// onSelect={handleYearSelected}
							itemsSelect={itemsSelectYear}
							validation={validation}
						/>
					</Col>

					<Col lg={12}>
						<Label for='header' className='form-label'>
							Encabezado
						</Label>
						<Input
							name='header'
							id='header'
							className='form-control'
							placeholder='Ingrese el encabezado'
							type='textarea'
							rows={5}
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.header || ''}
							invalid={validation.touched.header && validation.errors.header ? true : false}
						/>
						{validation.touched.header && validation.errors.header && (
							<FormFeedback type='invalid'>
								{validation.errors.header}
							</FormFeedback>
						)}
					</Col>
					<Col lg={6}>
						<Label for='link' className='form-label'>
							Enlace URL
						</Label>
						<Input
							name='link'
							id='link'
							className='form-control'
							placeholder='Ingrese una URL'
							type='text'
							validate={{ required: { value: true } }}
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.link || ''}
							invalid={
								validation.touched.link &&
									validation.errors.link ?
									true : false
							}
						/>
						{
							validation.touched.link &&
								validation.errors.link ?
								(
									<FormFeedback type='invalid'>
										{validation.errors.link}
									</FormFeedback>
								)
								:
								null
						}
					</Col>
					<Col lg={2}>
						<Label for='link' className='form-label'>
							Id BCN
						</Label>
						<Input
							name='bcn_code'
							id='bcn_code'
							className='form-control'
							placeholder='Ingrese Id BCN'
							type='text'
							validate={{ required: { value: true } }}
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.bcn_code || ''}
							invalid={
								validation.touched.bcn_code &&
									validation.errors.bcn_code ?
									true : false
							}
						/>
						{
							validation.touched.bcn_code &&
								validation.errors.bcn_code ?
								(
									<FormFeedback type='invalid'>
										{validation.errors.bcn_code}
									</FormFeedback>
								)
								:
								null
						}
					</Col>
					<Col lg={4}>
						<OSelect
							key='normative_status_id'
							label='Estado de Normativa'
							id='normative_status_id'
							name='normative_status_id'
							value={dataNormative?.normative_status_id || ''}
							requestApi={() => getNormativeStatusList()}
							validation={validation}
						/>
					</Col>
					<Col lg={4}>
						<OSelect
							key={`normative_entity_ids`}
							label='Entidad de la Normativa'
							id='normative_entity_ids'
							name='normative_entity_ids'
							value={dataNormative?.normative_entity_ids || ''}
							onSelect={handleNormativeEntitySelected}
							requestApi={() => getNormativeEntityList()}
							validation={validation}
							isMulti={true}
						/>
					</Col>
					<Col lg={4}>
						<OSelect
							key='normative_category_id'
							label='Tipo de Normativa'
							id='normative_category_id'
							name='normative_category_id'
							value={dataNormative?.normative_category_id || ''}
							onSelect={handleNormativeCategorySelected}
							requestApi={() => getNormativeCategoryList()}
							validation={validation}
						/>
					</Col>
					<Col lg={2}>
						<div className="form-check form-switch form-switch-right">
							<Label
								className="form-check-label text-muted"
								for="national"
							>
								{nationalCheck ? 'Nacional' : 'Internacional'}
							</Label>
							<input
								type="checkbox"
								className="form-check-input"
								id="national"
								checked={nationalCheck}
								onChange={handleNationalCheckboxChange}
							/>
						</div>
					</Col>
					<Col lg={2}>
						<div className="form-check form-switch form-switch-right">
							<Label
								className="form-check-label text-muted"
								for="internal"
							>
								{internalCheck ? 'Interna' : 'Externa'}
							</Label>
							<input
								type="checkbox"
								className="form-check-input"
								id="internal"
								checked={internalCheck}
								onChange={handleInternalCheckboxChange}
							/>
						</div>
					</Col>
				</Row>
				{/* </TabPane>
					<TabPane tabId='2'>
						<ObligationForm />
					</TabPane>
				</TabContent> */}
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className="label-icon"><Spinner size='sm' /></i>
						) : <i className="ri-save-3-line label-icon"></i>}
						{isEdit ? 'Editar' : 'Crear'} Normativa
					</button>
				</div>
			</div>
		</Form>
	);
};

export default NormativeForm;
